import { EKiwidTemplateKey, ELaboratoryTemplateKey } from './templates.enum';
import { EFinancialTransferType } from 'app/core/enums/financial.enum';

export enum EReportType {
    CUSTOMER = 'customer',
}

export enum EOrderItemsType {
    PRODUCT = 'product',
    SERVICE = 'service',
}

export enum EReportRelationshipTaskStatusFilter {
    EXPIRE_TODAY = 1,
    EXPIRED = 2,
    PENDING = 3,
    FINISHED = 4,
}

export enum ECustomerInvitationStatus {
    PENDING = 1,
    ACTIVE = 2,
    NOT_INVITED = 3,
    EXPIRED = 4,
    NO_EMAIL = 5
}

export enum EDateType {
    ENTRY_DATE = 0,
    ACCRUAL_DATE = 1,
    DUE_DATE = 2,
    PAYMENT_DATE = 3
}

export enum ECheckReportDateType {
    CHECK_DATE = 1,
    CREDIT_DATE = 2
}

export enum ESendEmailStatus {
    PROCESSED = 'processed',
    DROPPED = 'dropped',
    DELIVERED = 'delivered',
    DEFERRED = 'deferred',
    BOUNCE = 'bounce',
    BLOCKED = 'blocked'
}

export enum ESendEmailReasonType {
    INVALID_ADDRESS = 'invalid_address',
    UNCLASSIFIED = 'unclassified',
    TECHNICAL = 'technical_failure',
    CONTENT = 'content',
    REPUTATION = 'reputation',
    FREQUENCY_VOLUME = 'frequency_or_Volume_too_high',
    MAILBOX_UNAVAILABLE = 'mailbox_unavailable',
    SPAM_CONTENT = 'spam_content',
    UNSUBSCRIBED_ADDRESS = 'unsubscribed_address',
    BOUNCED_ADDRESS = 'bounced_address',
    SPAM_REPORTING_ADDRESS = 'spam_reporting_address',
    INVALID = 'invalid',
    OVER_PACKAGE_QUOTA = 'recipient_list_over_package_quota',
}

export enum ESendEmailEvent {
    OPEN = 'open',
    CLICK = 'click',
    SPAM_REPORT = 'spam report',
    PROCESSED = 'processed',
    DROPPED = 'dropped',
    DELIVERED = 'delivered',
    DEFERRED = 'deferred',
    BOUNCE = 'bounce',
    BLOCKED = 'blocked'
}

export enum EEmailKey {
    CUSTOMER_RELATIONSHIP_EMAIL = 'customer_relationship_email'
}

export type ESendEmailKey = EKiwidTemplateKey | ELaboratoryTemplateKey | EEmailKey;

export enum EReportFinancialCheckType {
    NONE = 'none',
    ACCOUNT = 'account',
    CHECK = 'check',
    CANCELLED = 'cancelled'
}
